<lui-dialog-container>
  <lui-dialog-header>
    <span class="mat-h2" i18n>Add a New Contact</span>
  </lui-dialog-header>
  <lui-dialog-content>
    <la-contact-form
      *ngIf="clientId"
      [loaded]="true"
      [clientId]="clientId"
      [clientsLoaded]="true"
      [showClientIdControl]="false"
      [showLanguageControl]="showLanguageControl"
      [showAddProducts]="false"
      (submitForm)="addContact($event)"
    ></la-contact-form>
  </lui-dialog-content>
  <lui-dialog-actions [align]="'between'">
    <button luiLink type="button" matDialogClose (click)="buttonClick()" i18n
      >Cancel</button
    >
    <button luiButton (click)="buttonClick()" i18n cdkFocusInitial
      >Add Contact</button
    >
  </lui-dialog-actions>
</lui-dialog-container>
